export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.atrizult.com/api/v1'
};
